import type { ScheduleTRPCInput } from '@risksmart-app/trpc/src/types';
import { mapScheduleToTRPC } from '@risksmart-app/trpc/src/types';
import type {
  UpdateChildObligationInput,
  UpdateObligationMutation,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import {
  namedOperations,
  UpdateObligationDocument,
} from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

type UpdateObligationTRPCInput = Omit<
  UpdateChildObligationInput,
  'schedule' | 'Adherence'
> &
  ScheduleTRPCInput & {
    Adherence: string;
  };

export const useUpdateObligation = createMutationHook({
  name: 'updateObligation',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.obligation.update.mutationOptions({ onSuccess }),
  mapInput: ({
    schedule,
    ...rest
  }: UpdateChildObligationInput): UpdateObligationTRPCInput => ({
    ...rest,
    ...mapScheduleToTRPC(schedule),
    Adherence: rest.Adherence ?? '',
  }),
  invalidate: (trpc) => [
    trpc.frontend.obligation.getById.queryKey(),
    trpc.frontend.obligation.register.queryKey(),
    trpc.frontend.obligation.obligationsByType.queryKey(),
    trpc.frontend.obligation.obligationList.queryKey(),
  ],
  // The tRPC update returns the full row; the legacy shape echoes the Id.
  mapResponse: (
    _result,
    input: UpdateChildObligationInput
  ): UpdateObligationMutation => ({
    updateChildObligation: {
      __typename: 'IdOutput',
      Id: input.Id,
    },
  }),
  graphqlDocument: UpdateObligationDocument,
  graphqlVariables: (input: UpdateChildObligationInput) => ({ object: input }),
  evictFields: ['obligation'],
  refetchQueries: [namedOperations.Query.getObligationById],
});
